export const NUMBER_OF_APPS_IN_PAGE = 18;
export const STRING_DESCRIPTION_LENGTH = 55;
export const MAXIMUM_DESCRIPTION_LENGTH = 1520;
export const STATUS_PUBLISHED = 'published';
